"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _colors = require("@material-ui/core/colors");
var _Typography = _interopRequireDefault(require("../Typography"));
var _classes = require("../../utils/classes");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      padding: theme.spacing(1, 1, 1, 2)
    },
    content: {
      order: 2,
      padding: theme.spacing(0, 1, 1, 0)
    },
    footer: {
      '& button': {
        margin: theme.spacing(0, 1)
      },
      display: 'flex',
      justifyContent: 'flex-end',
      order: 3
    },
    header: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      order: 1
    },
    headerIcon: {
      '&:focus': {
        boxShadow: "0 0 0 1.5px ".concat((0, _styles.alpha)(theme.palette.greyscale['800'], 0.87)),
        color: theme.palette.greyscale['900']
      },
      '&:hover': {
        background: '#FBF7FC',
        color: theme.palette.greyscale['900']
      },
      color: theme.palette.greyscale['700'],
      padding: theme.spacing(1)
    },
    headerStatic: {
      cursor: 'auto'
    },
    root: {
      background: '#FBF7FC',
      borderLeft: theme.spacing(1),
      borderLeftColor: _colors.purple[300],
      borderLeftStyle: 'solid',
      borderRadius: theme.spacing(0.5, 0.75, 0.75, 0.5),
      marginTop: 0,
      textAlign: 'left',
      width: '100%'
    },
    title: {
      padding: theme.spacing(1, 0, 1)
    }
  };
});
var defaultProps = {
  classes: {},
  dataMetrics: {
    root: 'fuse_insights_card'
  }
};

/*
 * The insights card can be used to display key ‘takeaways’ or ‘highlights’ relevant to
 * a particular section of a page. The insights card can be used to display textual information
 * along with badges or informational icons.
 * It’s recommended to avoid using interactive elements within this card.
 */
var _ref = /*#__PURE__*/_react["default"].createElement("span", null);
var _ref2 = /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null);
var _ref3 = /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null);
var InsightsCard = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
    _props$classes = props.classes,
    propClasses = _props$classes === void 0 ? {} : _props$classes,
    className = props.className,
    dataMetrics = props.dataMetrics,
    insightsCardActions = props.insightsCardActions,
    onCollapsed = props.onCollapsed,
    title = props.title,
    variant = props.variant;
  var classes = (0, _classes.mergeClasses)(useStyles(), propClasses);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isStaticMode = _useState4[0],
    setIsStaticMode = _useState4[1];
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var parseVariant = (0, _react.useCallback)(function () {
    if (variant === 'expanded') return setIsExpanded(true);
    if (variant === 'static') {
      setIsStaticMode(true);
      return setIsExpanded(true);
    }
    return setIsExpanded(false);
  }, [variant]);
  var handleExpandAction = function handleExpandAction() {
    if (!isStaticMode) {
      setIsExpanded(!isExpanded);
      if (onCollapsed) onCollapsed(isExpanded);
    }
  };
  (0, _react.useEffect)(function () {
    parseVariant();
  }, [parseVariant]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: (0, _classnames["default"])(classes.root, className),
    "data-metrics": mergedDataMetrics.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, (title || !isStaticMode) && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(classes.header, (0, _defineProperty2["default"])({}, classes.headerStatic, isStaticMode)),
    onClick: handleExpandAction,
    role: "presentation"
  }, title ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    align: "left",
    variant: "h6",
    className: classes.title
  }, title) : _ref, !isStaticMode && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    color: "inherit",
    "aria-label": "Help",
    classes: {
      root: classes.headerIcon
    }
  }, isExpanded ? _ref2 : _ref3)), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
    "in": isExpanded,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    component: "span",
    variant: "body1",
    color: "textSecondary"
  }, children), Boolean(insightsCardActions) && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.footer
  }, insightsCardActions)))));
});
InsightsCard.defaultProps = defaultProps;
InsightsCard.displayName = 'InsightsCard';
InsightsCard.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * InsightsCard action Bar component. For instance, it can be a `Button`.
   */
  insightsCardActions: _propTypes["default"].element,
  /**
   * Function called when user collapse and expand Card
   */
  onCollapsed: _propTypes["default"].func,
  /**
   * The title of the InsightsCard.
   */
  title: _propTypes["default"].string,
  /**
   * Kind of InsightsCard States.
   */
  variant: _propTypes["default"].oneOf(['collapsed', 'expanded', 'static'])
} : {};
var _default = InsightsCard;
exports["default"] = _default;